import React from 'react';

import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const ContributeButton = createReactClass({
  onClickFn(gaqArr, tabName) {
    _gaq.push(gaqArr);
    this.props.clickHandler(tabName);
  },
  render() {
    // takes this.props.contributeType as one of "review", "photo", or "track"
    // takes this.props.gaqArray such as ['_trackEvent','Trail Profile','Trail Feed']
    const buttonProps = {
      review: {
        id: 'review-fileupload-button',
        className: 'write-review',
        gaq: 'Write Review',
        text: StringConstantsMixin.strings.CONTRIBUTE.WRITE_REVIEW,
        tab: 'Reviews'
      },
      photo: {
        id: 'photo-fileupload-button',
        className: 'upload-photo',
        gaq: 'Upload Photos',
        text: StringConstantsMixin.strings.CONTRIBUTE.UPLOAD_PHOTOS,
        tab: 'Photos'
      },
      track: {
        id: 'track-fileupload-button',
        className: 'upload-track',
        gaq: 'Upload Tracks',
        text: StringConstantsMixin.strings.CONTRIBUTE.UPLOAD_RECORDINGS,
        tab: 'Recordings'
      },
      completed: {
        id: 'completed-fileupload-button',
        className: 'upload-completed',
        gaq: 'Add to completed',
        text: this.props.completedConnectionId
          ? StringConstantsMixin.strings.CONTRIBUTE.REMOVE_FROM_COMPLETED
          : StringConstantsMixin.strings.CONTRIBUTE.ADD_TO_COMPLETED,
        tab: 'Completed'
      }
    };
    const thisProps = buttonProps[this.props.contributeType];
    const { className } = thisProps;
    const gaqArr = this.props.gaqArray.slice(0);
    gaqArr.push(thisProps.gaq);
    return (
      <button
        id={thisProps.id}
        className={`${className} contribute-button upload-ugc-button`}
        onClick={this.onClickFn.bind(null, gaqArr, thisProps.tab)}
        data-test-id={thisProps.text}
      >
        {thisProps.text}
      </button>
    );
  }
});

export { ContributeButton };
